// ============================================================================
// ACCOUNT CASES ENDPOINTS (ACCT-CASES-001)
// ============================================================================
// Backend: AccountCasesController → /api/v1/AccountCases → BASE_PATH = '/AccountCases'.
// Single-source-of-truth read across all case types for one account.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const ACCT_CASES_BASE_PATH = '/AccountCases';

export const accountCasesEndpoints = {
  /** GET /api/v1/AccountCases/:accountId — 360 drill-down */
  byAccount: (accountId: ID) =>
    buildEndpointWithParams(`${ACCT_CASES_BASE_PATH}/:accountId`, { accountId }),
  /** GET /api/v1/AccountCases/actionable — actionable accounts list */
  actionable: () => buildEndpoint(`${ACCT_CASES_BASE_PATH}/actionable`),
  /** GET /api/v1/AccountCases/import-template — downloadable .xlsx template */
  importTemplate: () => buildEndpoint(`${ACCT_CASES_BASE_PATH}/import-template`),
  /** POST /api/v1/AccountCases/import — upload + upsert (multipart) */
  import: () => buildEndpoint(`${ACCT_CASES_BASE_PATH}/import`),
} as const;

export default accountCasesEndpoints;
